import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';
import reducers from '../reducers';
import { requestMiddleware } from '../middlewares';

const middlewares = applyMiddleware(
    ReduxThunk,
    requestMiddleware,
);

const store = createStore(reducers, {}, middlewares);

export default store;

